import apiWrapper, { list } from './helpers';

export default class ContributionTracker extends apiWrapper('/contribution_trackers') {

  static listByUser(opts) {
    list('/contribution_trackers/list_by_user', opts);
  }

}
